'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var cx = require('classnames');
var utilityFunctions = require('../../../utilityFunctions.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var Highlighted = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.highlight, highlight = _c === void 0 ? '' : _c, _d = _a.highlightClassName, highlightClassName = _d === void 0 ? 'fw-bold' : _d, _e = _a.text, text = _e === void 0 ? '' : _e, _f = _a.bypassEscape, bypassEscape = _f === void 0 ? false : _f;
    if (!highlight.trim()) {
        return jsxRuntime.jsx("span", tslib.__assign({ className: className }, { children: text }));
    }
    var highlightText = bypassEscape ? highlight : "".concat(utilityFunctions.escapeRegExp(highlight));
    var regex = new RegExp("(".concat(highlightText, ")"), 'gi');
    var parts = text.split(regex);
    return (jsxRuntime.jsx("span", tslib.__assign({ className: "m-0" }, { children: parts
            .filter(function (part) { return part; })
            .map(function (part, i) {
            return regex.test(part) ? (jsxRuntime.jsx("span", tslib.__assign({ className: cx__default.default('m-0', highlightClassName) }, { children: part }), i)) : (jsxRuntime.jsx("span", tslib.__assign({ className: cx__default.default('m-0', className) }, { children: part }), i));
        }) })));
};

exports.Highlighted = Highlighted;
//# sourceMappingURL=Highlighted.js.map
